// Interfaces
import { ITiersLoader } from "./interfaces";

// MUI
import { Skeleton, Stack } from "@mui/material";

const RegularSectionLoader = (props: { index: number }) => {
	const { index = 0 } = props;
	return (
		<Stack alignItems={"center"} spacing={1}>
			{!index && <Skeleton variant="rectangular" width={180} height={25} sx={{ borderRadius: "6px", marginBottom: "10px" }} />}
			<Stack spacing={1} direction={"row"} alignItems={"center"}>
				<Skeleton variant="rectangular" className="rounded-[6px]" width={90} height={30} />
				<Skeleton variant="text" width={100} height={20} className="!ml-[20px] mr-[15px]" />
			</Stack>
		</Stack>
	);
};

export default function DefaultTiersLoader(props: Readonly<ITiersLoader>) {
	const { tiers = 2, mt = 2, sx = { padding: "0 32px" }, buttons = false } = props;
	return (
		<Stack mt={mt} sx={sx}>
			<Stack spacing={1} width={800}>
				{Array.from(Array(tiers)).map((_, key) => {
					const itemKey = `default_tiers_loader_${key}`;
					return (
						<Stack key={itemKey} direction={"row"} spacing={4} width={662}>
							<Stack alignItems={"center"} spacing={1}>
								{!key && (
									<Skeleton
										variant="rectangular"
										width={100}
										height={25}
										sx={{ borderRadius: "6px", marginBottom: "10px" }}
									/>
								)}
								<Stack spacing={1} direction={"row"} alignItems={"center"}>
									<Skeleton variant="rectangular" width={65} height={30} sx={{ borderRadius: "6px" }} />
									<Skeleton variant="text" width={10} height={20} />
									<Skeleton variant="rectangular" width={65} height={30} sx={{ borderRadius: "6px" }} />
								</Stack>
							</Stack>
							<RegularSectionLoader index={key} />
							<RegularSectionLoader index={key} />
						</Stack>
					);
				})}
			</Stack>
			{buttons && (
				<Stack direction={"row"} justifyContent={"center"} mt={3} spacing={1} width={662}>
					<Skeleton variant="rectangular" width={120} height={28} sx={{ borderRadius: "6px" }} />
					<Skeleton variant="rectangular" width={120} height={28} sx={{ borderRadius: "6px" }} />
				</Stack>
			)}
		</Stack>
	);
}
